<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3">
                <div class="form-group col-lg-3">
                    <label for="city">{{ $t('omsz-form.labels.city_area') }}</label>
                    <multiselect id="city"
                                 v-model="city"
                                 track-by="name"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="cities"
                                 :allow-empty="false"
                                 :searchable="true"
                                 :disabled="isDisabled">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
                <div class="form-group col-lg-3">
                    <label for="start_date">{{ $t('omsz-form.labels.stat_date') }}</label>
                    <date-picker id="start_date"
                                 v-model="startDate"
                                 :format="YYYY"
                                 :editable="false"
                                 :default-value="new Date()"
                                 :disabled-date="notBeforeToday"
                                 value-type="YYYY-MM-DD"
                                 type="year"
                                 @change="selectStartDate"
                                 slots="icon icon-calendar">
                        <i slot="icon-calendar" class="icon icon-calendar"/>
                    </date-picker>

                </div>
                <div class="form-group col-lg-3">
                    <label for="end_date">{{ $t('omsz-form.labels.end_date') }}</label>
                    <date-picker id="end_date"
                                 v-model="endDate"
                                 :format="YYYY"
                                 :editable="false"
                                 :default-value="new Date()"
                                 :disabled-date="notBeforeToday"
                                 value-type="YYYY-MM-DD"
                                 type="year"
                                 @change="selectEndDate"
                                 slots="icon icon-calendar">
                        <i slot="icon-calendar" class="icon icon-calendar"/>
                    </date-picker>
                </div>
                <div class="form-group col-lg-3">
                    <label for="type">{{ $t('omsz-form.labels.type') }}</label>
                    <multiselect id="type"
                                 v-model="type"
                                 track-by="name"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :preselect-first="true"
                                 :options="types"
                                 :allow-empty="false"
                                 :searchable="true"
                                 :disabled="isDisabled">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
            </div>
            <div class="form-row justify-content-end">
                <div class="buttons">
                    <button type="button" id="clear_form" class="btn btn-link text-uppercase mr-3" @click="clearAll">
                        <span>{{ $t('omsz.buttons.clear_filters') }}</span>
                    </button>
                    <button id="send" class="btn btn-primary" :class="{'loader': isLoading}" type="submit">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div v-if="errorMessage">{{errorMessage}}</div>
        <response-file v-if="response && !errorMessage" v-model="response"/>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect"
import axios from 'axios'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/hu';
import ResponseFile from './ResponseFile.vue'

export default {
    name: 'manual-network',
    components: {
        Multiselect,
        ResponseFile,
        DatePicker,
    },
    props: {
        cities: {
            required: true
        },
        types: {
            required: true
        },
    },
    data() {
        return {
            city: null,
            type: null,
            startDate: null,
            endDate: null,
            isLoading: false,
            isDisabled: false,
            errorMessage: '',
            response: null,
            format: 'YYYY-MM-DD',
			form: {},
            disabledDates: {
                to: '',
                from: new Date(),
                days: '',
                daysOfMonth: '',
            }
        }
    },
    methods: {
        notBeforeToday(date) {
            const today = new Date();
            return date > today;
        },
        clearAll(e) {
            this.value = ''
            this.value2 = ''
            this.startDate = ''
            this.endDate = ''
            this.form = {}
        },
        selectStartDate(e) {
            const end = this.endDate;
            if(end && e > end) {
                this.form.end_date = ''
                this.endDate = ''
            }
            this.form.start_date =  e

        },
        selectEndDate(e) {
            const start = this.startDate;
            if( this.form.end_date && e <= start) {
                this.form.start_date = ''
                this.startDate = ''
            }
            this.form.end_date =  e
        },
        selectArea(e) {
            this.form.city =  e.value
        },
        selectType(e) {
            this.form.type =  e.value
        },
        async submit(e) {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.response = null;
            this.errorMessage = null;
            const form  = {
                city: this.city.value,
                start_date: this.startDate,
                end_date: this.endDate,
                type: this.type.value,
            }

            const options = {
                method: 'POST',
                headers: {'Accept-Language': window.Met.locale},
                url: '/api/manual-network',
                data: form,
            };

            try{
                const response = await axios(options);
                this.response = response.data
            }
            catch (error) {
                this.errorMessage = this.$t('omsz-form.errors.not_response')
            }
            finally {
                this.isLoading = false
            }
        }
    }
}
</script>
